

import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { useTranslation } from "react-i18next";
import { ScrollArea } from "./ui/scroll-area";

const PrivacyPolicy = () => {
    const { t } = useTranslation("settings");
    return (
        <>
            <Dialog >
                <DialogTrigger>
                    <span className="underline">Privacy Policy</span>
                </DialogTrigger>
                <DialogContent className="max-w-5xl">
                    <DialogHeader>

                        <DialogTitle >Privacy Policy</DialogTitle>
                    </DialogHeader>

                    <ScrollArea className="flex  flex-col gap-4 max-h-screen overflow-hidden">

                        <div className="flex flex-col gap-4">
                            <p>
                                This privacy notice for Bytemine Technologies Limited (doing
                                business as Level2) (&quot;Level2 ,&quot;
                                &quot; we,&quot; &quot; us,&quot; or &quot;our&quot;), describes
                                how and why we might collect, store, use, and/or share
                                (&quot;process) your information when you use our services
                                (&quot;Services&quot;).
                            </p>
                            <ul className="flex flex-col gap-4">
                                <li>
                                    What personal information do we process?
                                    <p>
                                        When you visit, use, or navigate our Services, we may
                                        process personal information depending on how you interact
                                        with Level2 and our Services, the choices you make,
                                        and the products and features you use. We collect personal
                                        information that you voluntarily provide to us when you
                                        register on the Services, express an interest in obtaining
                                        information about us or our products and Services, when you
                                        participate in activities on the Services, or otherwise when
                                        you contact us.
                                    </p>
                                    <p className="mt-3">
                                        Personal Information Provided by You - The personal
                                        information that we collect depends on the context of your
                                        interactions with us and the Services, the choices you make,
                                        and the products and features you use. All personal
                                        information that you provide to us must be true, complete,
                                        and accurate, and you must notify us of any changes to such
                                        personal information.
                                    </p>
                                    <p className="mt-3">
                                        Information automatically collected - We automatically
                                        collect certain information when you visit, use, or navigate
                                        the Services. This information does not reveal your specific
                                        identity (like your name or contact information) but may
                                        include device and usage information, such as your IP
                                        address, browser and device characteristics, operating
                                        system, language preferences, referring URLs, device name,
                                        country, location, information about how and when you use
                                        our Services, and other technical information. This
                                        information is primarily needed to maintain the security and
                                        operation of our Services, and for our internal analytics
                                        and reporting purposes.
                                    </p>
                                </li>
                                <li >
                                    Do we process any sensitive personal information?
                                    <p>We do not process sensitive personal information.</p>
                                </li>
                                <li >
                                    Do you receive any information from third parties?
                                    <p>We do not receive any information from third parties.</p>
                                </li>
                                <li >
                                    How do you process my information?
                                    <p>
                                        We process your information to provide, improve, and
                                        administer our Services, communicate with you, for security
                                        and fraud prevention, and to comply with law. We may also
                                        process your information for other purposes with your
                                        consent. We process your information only when we have a
                                        valid legal reason to do so.
                                    </p>
                                </li>
                                <li >
                                    In what situations and with which parties do we share personal
                                    information?
                                    <p>
                                        We may share information in specific situations and with
                                        specific third parties.
                                    </p>
                                </li>
                                <li >
                                    How long do we keep your information?
                                    <p>
                                        We keep your information for as long as necessary to fulfill
                                        the purposes outlined in this privacy notice unless
                                        otherwise required by law.
                                    </p>
                                    <p className="mt-3">
                                        We will only keep your personal information for as long as
                                        it is necessary for the purposes set out in this privacy
                                        notice, unless a longer retention period is required or
                                        permitted by law (such as tax, accounting, or other legal
                                        requirements). No purpose in this notice will require us to
                                        keep your personal information for longer than the period of
                                        time in which users have an account with us.
                                    </p>
                                    <p className="mt-3">
                                        When we have no ongoing legitimate business need to process
                                        your personal information, we will either delete or
                                        anonymize such information, or, if this is not possible (for
                                        example, because your personal information has been stored
                                        in backup archives), then we will securely store your
                                        personal information and isolate it from any further
                                        processing until deletion is possible.
                                    </p>
                                </li>
                                <li >
                                    How do we keep your information safe?
                                    <p>
                                        We have organizational and technical processes and
                                        procedures in place to protect your personal information.
                                        However, no electronic transmission over the internet or
                                        information storage technology can be guaranteed to be 100%
                                        secure, so we cannot promise or guarantee that hackers,
                                        cybercriminals, or other unauthorized third parties will not
                                        be able to defeat our security and improperly collect,
                                        access, steal, or modify your information.
                                    </p>
                                </li>
                                <li >
                                    What are your rights?
                                    <p>
                                        Depending on where you are located geographically, the
                                        applicable privacy law may mean you have certain rights
                                        regarding your personal information.
                                    </p>
                                </li>
                                <li >
                                    How do I exercise my rights?
                                    <p>
                                        The easiest way to exercise your rights is by filling out
                                        our data subject request form available by contacting us. We
                                        will consider and act upon any request in accordance with
                                        applicable data protection laws
                                    </p>
                                </li>
                                <li >
                                    How can you contact us about this notice?
                                    <p>
                                        If you have questions or comments about this notice, you may
                                        email us at contact@trylevel2.com
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </ScrollArea>
                </DialogContent>
            </Dialog >
        </>
    )
}
export default PrivacyPolicy;